<template>
  <div class="detail">
    <div class="header">
      <div class="title">水质监测站详情</div>
    </div>

    <div class="content contentItem" style="padding-top: 2vh;">
      <div class="item">
        <div class="label">编号：</div>
        <div class="value">{{ detail.code }}</div>
      </div>
      <div class="item">
        <div class="label">名称：</div>
        <div class="value">{{ detail.name }}</div>
      </div>
    </div>


    <div class="tabs-container">
        <div class="tab" :class="{ active: activeTab === '1' }" @click="activeTab = '1'">统计数据</div>
        <div class="tab" :class="{ active: activeTab === '2' }" @click="activeTab = '2'">实时数据</div>
    </div>
      <div class="tabDetail" v-if="activeTab === '1'">
          <div class="tabDetailQuery">
            <RangePickerField style="margin: 0.5rem 0.2rem;width: 28%;" labelWidth="0"
                    v-model="selectedDate" :placeholder="['开始日期', '结束日期']" :disabled="false" @change="handleDateChange"/>
            <SelectField style="margin: 0.5rem 0.2rem;width: 20%;" label-width="0" id="category" v-model="queryOption" :options="queryOptions"/>
            <SelectField style="margin: 0.5rem 0.2rem;width: 20%;" label-width="0" id="category" v-model="interval" :options="statInterval"/>
             <a-space style="margin-left: 1.5rem;">
                <ButtonField text="查询" @click="query" secondary />
                <ButtonField text="重置" primary @click="reset"/>
             </a-space>
          </div>
          <div style="padding-top: 1vh"></div>
          <Chart id="history-chart" :list="chartList" :rainList="rainList" />
          <div style="padding-top: 1vh"></div>
          <Tablelist
                  :showCheckbox="false"
                  :list="tableList"
                  :columns="tableColumns"
          />

      </div>
      <div class="tabDetail" v-if="activeTab === '2'">
          <div class="content">
              <div class="item">
                  <div class="label">溶解氧：</div>
                  <div class="value">{{ realTimeData.doxygen ? realTimeData.doxygen + "mg/L" : "--" }}</div>
              </div>
              <div class="item">
                  <div class="label">透明度：</div>
                  <div class="value">{{ realTimeData.ss ? realTimeData.ss + "cm" : "--" }}</div>
              </div>
              <div class="item">
                  <div class="label">氧化还原电位：</div>
                  <div class="value">{{ realTimeData.orp ? realTimeData.orp + "mV" : "--" }}</div>
              </div>

              <div class="item">
                  <div class="label">化学需氧量：</div>
                  <div class="value">{{ realTimeData.cod ? realTimeData.cod + "mg/L" : "--" }}</div>
              </div>

              <div class="item">
                  <div class="label">酸碱度：</div>
                  <div class="value">{{ realTimeData.ph ? realTimeData.ph : "--" }}</div>
              </div>

              <div class="item">
                  <div class="label">氨氮：</div>
                  <div class="value">{{ realTimeData.nh4n ? realTimeData.nh4n + "mg/L" : "--" }}</div>
              </div>
              <div class="item">
                  <div class="label">更新时间：</div>
                  <div class="value">{{ realTimeData.ts ? realTimeData.ts : "--" }}</div>
              </div>
          </div>
      </div>
  </div>
</template>
  
<script>
import Chart from "./chart.vue";
import moment from "moment";
import request from "@/api/request";
import { mapGetters } from "vuex";
export default {
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {Chart
  },
  data() {
    return {
      activeTab: "1",
      selectedDate: [moment().subtract(1, "months"), moment()],
      queryOption: "cod",
      queryOptions: [
        {
          name: "cod",
          value: "cod",
        },
        {
          name: "orp",
          value: "orp",
        },
        {
          name: "氨氮",
          value: "nh4n",
        },
        {
          name: "酸碱度",
          value: "ph",
        },
        {
          name: "溶解氧",
          value: "doxygen",
        },

        {
          name: "透明度",
          value: "ss",
        },
      ],
      interval: "1d",
      loading: false,
      chartList: [],
      rainList: [],
      tableList: [],
      tableColumns: [
          {
              key: 'ss',
              title: '透明度',
              field: 'ss',
              infotype: 'text'
          },
          {
              key: 'cod',
              title: 'cod',
              field: 'cod',
              infotype: 'text'
          },
          {
              key: 'orp',
              title: 'orp',
              field: 'orp',
              infotype: 'text'
          },
          {
              key: 'nh4n',
              title: '氨氮',
              field: 'nh4n',
              infotype: 'text'
          },
          {
              key: 'ph',
              title: '酸碱度',
              field: 'ph',
              infotype: 'text'
          },
          {
              key: 'doxygen',
              title: '溶解氧',
              field: 'doxygen',
              infotype: 'text'
          },
          {
              key: 'ts',
              title: '更新时间',
              field: 'ts',
              infotype: 'text'
          },
      ],
      realTimeData: {},
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),

    statInterval() {
      return this.findDataDict("statInterval");
    },
  },

  watch: {
    detail: {
      handler() {
        if (this.detail.sn) {
          this.getRealTimeData();
          this.getHistoryData();
        }
      },
      deep: true,
    },
  },

  methods: {
    handleDateChange(dates, dateStrings) {
        console.log('日期范围变化：', dates, dateStrings);
    },
    getHistoryData() {
      this.loading = true;
      request({
        url: "/data-service/dev/stat",
        method: "post",
        data: {
          devType: "waterquality",
          beginDate: this.selectedDate[0].format("YYYY-MM-DD") + " 00:00:00",
          endDate: this.selectedDate[1].format("YYYY-MM-DD") + " 00:00:00",
          eids: [this.detail.sn],
          interval: this.interval,
        },
      })
        .then((res) => {
          if (Array.isArray(res)) {
            this.tableList = res;

            this.chartList = res.map((item) => {
              return {
                ts: item.ts,
                name: this.queryOptions.find(
                  (item) => item.value === this.queryOption
                ).name,
                value: item[this.queryOption],
              };
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });

      request({
        url: "/model-analysis/pipe/device/query/type/rainFall",
      }).then((res) => {
        console.log("rain config", res);

        if (Array.isArray(res) && res.length > 0) {
          if (res[0].sn) {
            request({
              url: "/data-service/dev/stat",
              method: "post",
              data: {
                devType: "rainFall",
                beginDate:
                  this.selectedDate[0].format("YYYY-MM-DD") + " 00:00:00",
                endDate:
                  this.selectedDate[1].format("YYYY-MM-DD") + " 00:00:00",
                eids: [res[0].sn],
                interval: this.interval,
              },
            }).then((res) => {
              console.log("flow detail", res);
              if (Array.isArray(res)) {
                this.rainList = Object.freeze(
                  res.map((item) => {
                    return {
                      ts: item.ts,
                      name: "雨量",
                      value: item.rainfall,
                    };
                  })
                );
              }
            });
          }
        }
      });
    },

    query() {
      this.getHistoryData();
    },
    reset() {
      this.selectedDate = [moment().subtract(1, "months"), moment()];
      this.queryOption = "cod";
      this.interval = "1d";
      this.getHistoryData();
    },

    getRealTimeData() {
      request({
        url: "/data-service/dev/realTime",
        method: "post",
        data: {
          devType: this.detail.type, // 获取类型
          eids: [this.detail.sn],
        },
      }).then((res) => {
        this.realTimeData = res || {};
      });
    },
  },
};
</script>
  
  
<style lang="less" scoped>
.detail {
  position: fixed;
  top: 11vh;
  height: 87vh;
  overflow-y: auto;
  right: 1vw;
  z-index: 99;
  width: 50vw;
  background-color: var(--detail-bgcolor);
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  border: 1px solid #065645;
  color: #adadad;
  & > .header {
    background-color:rgba(0, 0, 0, 0.9);
    color: #00ff96;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1vw;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .content {
    padding: 0 1vw;
    display: flex;
    flex-direction: column;
    gap: 1vh;
    color: #adadad;
    .item {
      display: flex;
      align-items: center;
      padding: 0.5rem;
      .label {
        min-width: 4em;
      }

      .value {
        color: var(--theme-color);
      }
    }
  }

}

.tabs-container {
  display: flex;
  justify-content: start;
  margin-bottom: 10px;
  border-bottom: 1px solid #a2a2a3;
  width: 96%;
  margin: auto;
}
.tab {
  cursor: pointer;
  padding: 10px;
}
.tab.active {
  color: #00ff96;
  border-bottom: 1px solid #00ff96;
  width: 10%;
}
.tabDetail{
  width: 96%;
  margin: auto;
  padding: 1rem 0;
  .tabDetailQuery{
    display: flex;
    justify-content: start;
  }
}
</style>